import { styled } from '@mui/material'
import { SxProps } from '@mui/system'

export const receiptButton: SxProps = {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
    height: 55,
}

export const PreviewImg = styled('img')({
    objectFit: 'cover',
    display: 'none',
})
